import React, { useState } from 'react';
import { Layout, Row, Col } from 'antd';
import BankCard from './BankCard';
import { ReactComponent as Mastercard } from '../../../asset/svg/paymentCardType/mastercard.svg';
import { ReactComponent as Visa } from '../../../asset/svg/paymentCardType/visa.svg';
import { ReactComponent as AddNewIcon } from '../../../asset/svg/paymentCardType/addNewIcon.svg';

const cards = [
  { code: '3901', date: '08/22', id: 1, logo: <Visa />, name: 'TBC' },
  { code: '3901', date: '08/22', id: 2, logo: <Mastercard />, name: 'BOG' },
  { code: '3901', date: '08/22', id: 3, logo: <Visa />, name: 'TBC' }
];

const PaymentMethod = () => {
  const [selected, setSelected] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  return (
    <Layout
      onClick={(e) => (e.currentTarget === e.target ? setSelected(true) : setSelected(false))}
      style={{
        alignItems: 'center',
        backgroundColor: '#F0F4FF',
        borderRadius: '10px',
        justifyContent: 'center',
        marginLeft: '34px',
        padding: '40px 0px 40px 0px',
        width: '744px'
      }}
    >
      {cards.map(({ id, logo, name, date, code }) => {
        return (
          <BankCard
            key={id}
            code={code}
            date={date}
            id={id}
            logo={logo}
            name={name}
            selectedId={selectedId}
            selectState={selected}
            setSelectedId={setSelectedId}
          />
        );
      })}
      <Row
        style={{
          alignItems: 'center',
          border: '1px solid #CAD8FF',
          borderRadius: '10px',
          boxSizing: 'border-box',
          height: '62px',
          justifyContent: 'center',
          width: '356px'
        }}
      >
        <Col style={{ height: '20px', width: '20px' }}>
          <AddNewIcon style={{ height: '20px', width: '20px' }} />
        </Col>
        <Col style={{ marginLeft: '10px' }}>Add New Payment Method</Col>
      </Row>
    </Layout>
  );
};

export default PaymentMethod;
